export default {
  startingLineups: {
    title: "Escalações iniciais",
    labels: {
      confirmed: "CONFIRMADO",
      expected: "ESPERADO",
      tbd: "A DEFINIR",
      noLineupAvailable: "Nenhuma escalação disponível",
    },
    empty: {
      title: "Nenhuma escalação disponível",
    },
  },
};